import React from "react"
import translatesObj from "translates/translation.json"

interface ErrorSummaryProps {
  errors: any
  trail?: string[]
}

const ErrorSummary: React.FC<ErrorSummaryProps> = ({ errors, trail = [] }) => {
  const _translates: any = translatesObj
  // --- 1) Si estamos en un array ------------------------------------------
  if (Array.isArray(errors)) {
    return (
      <>
        {errors.map(({ index, fields = [], ...subArrays }) => (
          <div key={`${trail.join(".")}-${index}`} className="ml-4">
            {fields.length > 0 && (
              <p className="text-sm mb-2 px-2">
                {`• En ${trail.join(".")} # ${index + 1}, verifica los campos: ${fields
                  ?.map((_field: string) =>
                    _field.includes(".") ? _translates[_field.split(".")[-1]] : _translates[_field] || _field,
                  )
                  .join(", ")}`}
              </p>
            )}

            {/* procesar arrays anidados */}
            {Object.entries(subArrays).map(([subKey, subVal]) => (
              <ErrorSummary key={subKey} errors={subVal} trail={[...trail, subKey]} />
            ))}
          </div>
        ))}
      </>
    )
  }

  // --- 2) Estamos en un objeto --------------------------------------------
  if (errors && typeof errors === "object") {
    // 2a) agrupar los leaf fields (boolean true) en este nivel ------------
    const leafFields = Object.keys(errors).filter((k) => errors[k] === true)

    return (
      <>
        {leafFields.length > 0 && (
          <p className={`text-sm mb-2`}>
            {trail.length
              ? `- En ${trail.join(".")} verifica los campos: ${leafFields
                  .map((_field: string) =>
                    _field.includes(".") ? _translates[_field.split(".")[-1]] : _translates[_field] || _field,
                  )
                  .join(", ")}`
              : `Verifica los campos: ${leafFields
                  .map((_field: string) =>
                    _field.includes(".") ? _translates[_field.split(".")[-1]] : _translates[_field] || _field,
                  )
                  .join(", ")}`}
          </p>
        )}

        {/* 2b) procesar hijos no-booleanos (objetos o arrays) --------------- */}
        {Object.entries(errors).map(([k, v]) =>
          v === true ? null : <ErrorSummary key={`${trail.join(".")}-${k}`} errors={v} trail={[...trail, k]} />,
        )}
      </>
    )
  }

  // --- 3) Primitivos / null -----------------------------------------------
  return null
}

export default ErrorSummary
